import { render, staticRenderFns } from "./NMapPolygon.vue?vue&type=template&id=12e848a9&"
import script from "./NMapPolygon.vue?vue&type=script&lang=ts&"
export * from "./NMapPolygon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports